import { FeatureToggle } from './feature-toggle.entity';
import { FeatureToggleProperties } from './feature-toggle.properties.entity';
import sift from 'sift';

export class FeatureTogglesProvider {
    static getValue(featureToggle: FeatureToggle, properties?: Partial<FeatureToggleProperties>) {
        const conditions = featureToggle.conditions || [];

        for (const { expression, value } of conditions) {
            const match = sift(expression);

            if (match(properties)) {
                return value;
            }
        }

        return featureToggle.defaultValue;
    }
}
